// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bba_a bha_g"};